import React from 'react';

import { Typography } from '@mui/material';

import { numberWithCommas } from '@clearverify/utils';

import { DashboardEmployeeUserStatsResponse } from 'src/api';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockEmployeeUserStatsProps = {
  employeeCounts: DashboardEmployeeUserStatsResponse;
  loading: boolean;
};

export const DashboardOverviewBlockEmployeeUserStats: React.FC<
  DashboardOverviewBlockEmployeeUserStatsProps
> = ({ employeeCounts, loading }) => {
  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={`${numberWithCommas(employeeCounts.percentage)}%`}
      title="Employee Users Percentage"
      subtitle={
        <React.Fragment>
          {`${employeeCounts.total} Total ( `}
          <Typography component="span" variant="body2" color="success.main">{`${
            employeeCounts.breakdown.Active
          } Active`}</Typography>
          {' / '}
          <Typography component="span" variant="body2" color="warning.main">{`${
            employeeCounts.breakdown.Pending
          } Pending`}</Typography>
          {' / '}
          <Typography component="span" variant="body2" color="error.main">{`${
            employeeCounts.breakdown.Inactive
          } Inactive`}</Typography>
          {' )'}
        </React.Fragment>
      }
    />
  );
};
